<script lang="ts" setup>
import Card3 from '@/components/Card/Card3.vue'
import Content from './components/Content.vue'
import Faq from './components/Faq.vue'
import Side from './components/Side.vue'
import Slide from './components/Slide.vue'
import SideMobile from './components/SideMobile.vue'
import Title2 from '@/components/Title/Title2.vue'
import BlockEditor from '@/components/Block/G_block_editor.vue'
import { useGlobalStore, useEventStore } from '@/stores'
import type { IEventSubscribe, IEvent } from '@/utils/types/Event'
import useSeo from './seo'

const route = useRoute()
const globalStore = useGlobalStore()
const eventStore = useEventStore()
const id = route.params.eventId as string
await eventStore.fetchEvent(id)
const recommends = computed(() => eventStore.recommends)
const event = computed(() => eventStore.event)
const form = reactive({ email: '' })
const handleSubmitSubscribe = async () => {
  if (!isEmail(form.email)) {
    globalStore.setDialogVisible({
      visible: true,
      title: '提示',
      message: '請填寫正確的電子信箱。',
    })
    return
  }
  const subscribeData = {
    email: form.email,
    categories: event.value?.theme_categories.map(o => o.id)
  } as IEventSubscribe
  if (await eventStore.postEventSubscribe(subscribeData)) {
    globalStore.setDialogVisible({
      visible: true,
      title: '提示',
      message: '訂閱相關活動提交成功。',
    })
    form.email = ''
  }
}

onMounted(() => {
  nextTick(() => {
    eventStore.fetchEventRecommends(id)
  })
})

useSeo(event.value as IEvent)
</script>

<template>
  <section class="events-inner">
    <div class="events-inner__side">
      <Side :event="event" v-model:email="form.email" :submit-subscribe="handleSubmitSubscribe" />
    </div>
    <div class="events-inner__content">
      <Content :event="event" />
      <BlockEditor :data="{ text: event?.content || '' }" />
      <Faq :event="event" />
      <Slide :highlights="event?.highlights" v-if="event?.highlights && event?.highlights.length > 0" />
    </div>
    <div class="events-inner__bottom">
      <div class="events-inner__bottom__item" v-if="recommends.length > 0">
        <Title2 :data="{
          en: 'recommendation',
          tw: '相關推薦'
        }" class="events-inner__bottom__title" />
        <ul class="events-inner__list">
          <li v-for="item in recommends" :key="item.id">
            <Card3 :item="item" class="events__list__card" />
          </li>
        </ul>
      </div>
      <div class="events-inner__bottom__item" v-if="false">
        <Title2 :data="{
          en: 'recently viewed',
          tw: '瀏覽過的活動'
        }" class="events-inner__bottom__title" />
        <ul class="events-inner__list">
          <li v-for="item in recommends">
            <!-- <Card3 :item="item" class="events__list__card" /> -->
          </li>
        </ul>
      </div>
    </div>
    <div class="events-inner__mobile" :class="{ isOpen: globalStore.isScrollMenuClose }">
      <SideMobile :event="event" v-model:email="form.email" :submit-subscribe="handleSubmitSubscribe" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.events-inner {
  @include grid(12, 24);

  @include max-media(990) {
    @include grid(4, 24);
  }

  &__breadcrumb {
    grid-column: 1 / span 12;
    margin-bottom: toRem(10);

    @include max-media(990) {
      grid-column: 1 / span 4;
    }
  }

  &__side {
    grid-column: 1 / span 4;

    @include max-media(990) {
      display: none;
    }
  }

  &__content {
    @include max-media(990) {
      grid-column: 1 / span 4;
    }

    grid-column: 5 / span 8;
  }

  &__bottom {
    grid-column: 1 / span 12;
    padding-top: toRem(380);

    @include max-media(990) {
      grid-column: 1 / span 4;
      padding-top: toRem(110);
    }

    @include max-media(480) {
      padding-top: toRem(55);
    }

    &__title {
      margin-bottom: toRem(78);

      @include max-media(480) {
        margin-bottom: toRem(48);
      }
    }

    &__item {
      margin-bottom: toRem(25);
    }
  }

  &__mobile {
    @include min-media(991) {
      display: none;
    }

    @include max-media(990) {
      position: fixed;
      left: 0;
      bottom: toRem(50);
      z-index: 10;
      width: 100%;
      background-color: $color-white-2;
      transition: all 0.5s ease-in-out;

      &.isOpen {
        bottom: 0;
      }
    }
  }
}

.events-inner {
  &__list {
    display: grid;
    column-gap: toRem(24);
    grid-template-columns: repeat(auto-fill, calc((100% - 24px) / 2));

    @include max-media(990) {
      grid-template-columns: repeat(auto-fill, 100%);
    }

    li {
      margin-bottom: toRem(24);
    }
  }
}
</style>
<style lang="scss">
.events-inner {
  &__bottom {
    .events__list__card {
      .card3 {
        &__status {
          background-color: $color-brand-4_1;
        }
      }
    }
  }
}
</style>
